import { ObjectShim } from '~/helpers/shims/object-shim';

export const isUndefined = <T>(value: T): boolean => value === undefined && value === void 0;
export const isNil = <T>(value: T): boolean => isUndefined(value) || value === null;
export const openInNewTab = (url: string): void => window.open(url, '_blank')?.focus();
export const isEqual = <T, V>(a: T, b: V): boolean => {
  if (a instanceof Object && ObjectShim.isObject(a) && b instanceof Object && ObjectShim.isObject(b)) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    return Object.keys(a).every(key => isEqual(a[key], b[key]));
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }

    return a.every((aValue, index) => isEqual(aValue, b[index]));
  }

  return Object.is(a, b);
};
